import { Button, Image, Modal } from "react-bootstrap";
import React from "react";
import ModelBodyMain from "./ModelBodyMain";

export const ManageReservationTable = () => {
  return (
    <React.Fragment>
      <thead className="sd_table_thead">
        <tr>
          <th className="request-number" style={{ width: "20%" }}>
            <p className="font_16_r">Title</p>
          </th>

          <th className="total-pax" style={{ width: "15%" }}>
            <p className="font_16_r">Date</p>
          </th>
          <th className={"location"} style={{ width: "15%" }}>
            <p className="font_16_r">Start Time</p>
          </th>

          <th className="total-pax" style={{ width: "15%" }}>
            <p className="font_16_r">End Time</p>
          </th>

          <th className="action text-center" style={{ width: "35%" }}>
            <p className="font_16_r">Action</p>
          </th>
        </tr>
      </thead>
    </React.Fragment>
  );
};

export const ManageReservationTableBody = (props) => {
  const [open, showModel] = React.useState(false);

  return (
    <React.Fragment>
      <tbody className="w-100 seating-dashboard-body-new">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr
                  className={`cursor enGrayBorderBox sd_body_tr`}
                  // onClick={showTr}
                >
                  <td
                    className="td_b_g order-type-Image"
                    style={{ width: "20%" }}
                  >
                    Music Event
                  </td>
                  <td style={{ width: "15%" }}>25 Aug 2020</td>
                  <td style={{ width: "15%" }}>12 PM</td>

                  <td style={{ width: "15%" }}>4 PM</td>

                  <td style={{ width: "35%" }}>
                    <div
                      className={
                        props.displayButton !== true
                          ? "action-section-body d-flex align-items-center justify-content-center"
                          : "action-section-body align-items-center"
                      }
                    >
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={() => {
                          showModel(true);
                        }}
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>{" "}
                      <Button variant="link" className="enIconBtn mr-3">
                        <i
                          class="fa fa-trash"
                          style={{ color: "#000000" }}
                          title="Delete"
                        ></i>
                      </Button>
                    </div>
                  </td>
                </tr>
                <div>
                  <Modal
                    show={open}
                    onHide={() => {
                      showModel(false);
                    }}
                    centered
                    size="lg"
                  >
                    <Modal.Header className="border-0 pl-4" closeButton>
                      <Modal.Title className="f24-700">
                      Edit Reservation Calendar
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4 f16-500">
                      <ModelBodyMain />
                      
                    </Modal.Body>
                  </Modal>
                </div>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};
